import { randomNumber } from '@/helpers/helpers';
import adSlotInfo from '@/data/adSlotInfo.json'

const adSenseSourcePercentage = { windalert: 15, fishweather: 70 }
const staticPrimaryActivities = { fishweather: 'Fish', other: 'Wind', both: 'Wind' }

function setAdSource(brand, member_level) {
  if (member_level >= 46) return 'gpt'

  const brandLower = brand.toLowerCase()
  if (!(brandLower in adSenseSourcePercentage)) return 'gpt'

  return randomNumber(1, 100) <= adSenseSourcePercentage[brandLower] ? 'adsense' : 'gpt'
}

function scaledActivityThreshold(percentage, brand) {
  return percentage / (100 - adSenseSourcePercentage[brand]) * 100
}

function getPrimaryActivity(brand) { 
  const randomNum = randomNumber(1, 100)
  const brandLower = brand.toLowerCase()

  if (brandLower === 'windalert') {
    if (randomNum <= scaledActivityThreshold(5, 'windalert')) return 'Wind'
    if (randomNum <= scaledActivityThreshold(15, 'windalert')) return 'Sail'
    return 'Kite'
  }

  if (brandLower === 'ikitesurf') return 'Kite'

  if (brandLower === 'iwindsurf') {
    return randomNum <= 20 ? 'Wind' : 'Kite'
  }

  if (brandLower === 'sailflow') {
    return randomNum <= 30 ? 'Kite' : 'Sail'
  }

  if (brandLower === 'fishweather') {
    return randomNum <= scaledActivityThreshold(10, 'fishweather') ? 'Kite' : 'Sail'
  }

  return null
}

function getBrandPrimaryActivity(brand) {
  const brandLower = brand.toLowerCase()
  return staticPrimaryActivities[brandLower] || getPrimaryActivity(brandLower)
}

export default (parameters) => {
  const { brand, member_level } = parameters

  return {
    ads_allowed: false,
    gpt_primary_activity: getBrandPrimaryActivity(brand),
    mrec_primary_activity: getBrandPrimaryActivity(brand),
    ad_source: setAdSource(brand, member_level),
    mrec_ad_source: setAdSource(brand, member_level),
    ad_slot_info: adSlotInfo,
    footer_ad: false
  }
}
